/**
 * Normaliza a 10 dígitos nacionales (celular Colombia).
 * Acepta espacios, guiones, +57 o prefijo 57.
 */
export function normalizeColombiaPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.startsWith('57') && digits.length >= 12) {
    return digits.slice(2, 12);
  }
  if (digits.startsWith('57') && digits.length === 11) {
    return digits.slice(2);
  }
  return digits;
}

/** Celular colombiano: 10 dígitos, empieza en 3 (ej. 3154448492). */
export function isValidColombiaMobile10(digits) {
  return /^3\d{9}$/.test(digits);
}

export const CO_PHONE_ERROR_MSG =
  'Ingresa un celular colombiano válido: 10 dígitos sin +57 (ejemplo: 3154448492).';

/**
 * Número para wa.me (E.164 sin +): 57 + 10 dígitos para celular Colombia.
 */
export function toWhatsAppNumber(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';

  if (digits.startsWith('57') && digits.length === 12) {
    return digits;
  }
  if (digits.startsWith('57') && digits.length > 12) {
    return digits.slice(0, 12);
  }
  if (digits.length === 10 && digits.startsWith('3')) {
    return `57${digits}`;
  }
  if (digits.length === 11 && digits.startsWith('57')) {
    return digits;
  }

  return digits;
}
